<template>
  <div class="text-left">
    <b-form @submit.prevent="save">
      <div class="row">
        <div class="col-md-12">
          <b-form-group
            id="input-group-postalAddress"
            :label="`Contact address`"
            label-for="input-postalAddress"
          >
            <b-form-input
              v-model="model.applicant.postalAddress"
              :id="`input-postalAddress`"
              :type="`text`"
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-6" v-if="false">
          <b-form-group
            id="input-group-postCode"
            :label="`Post code`"
            label-for="input-postCode"
            required
          >
            <b-form-input
              v-model="model.applicant.postCode"
              :id="`input-postCode`"
              :type="`text`"
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-6">
          <b-form-group
            id="input-group-city"
            :label="`City`"
            label-for="input-city"
          >
            <b-form-input
              v-model="model.applicant.city"
              :id="`input-city`"
              :type="`text`"
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-6">
          <b-form-group
            id="input-group-state"
            :label="`State`"
            label-for="input-state"
          >
            <b-form-input
              v-model="model.applicant.state"
              :id="`input-state`"
              :type="`text`"
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="input-group-originCountry">Country</label>
            <div class="mb-3">
              <v-select
                id="input-group-originCountry"
                v-model="model.applicant.originCountry"
                label="country_name"
                :options="countries"
              >
                <template #search="{attributes, events}">
                  <input
                    class="vs__search"
                    :required="!model.applicant.originCountry"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <b-form-group
            id="input-group-passportNumber"
            :label="passportLabel"
            label-for="input-passportNumber"
          >
            <b-form-input
              v-model="model.applicant.passportNumber"
              :id="`input-passportNumber`"
              :type="`text`"
              required
            ></b-form-input>
          </b-form-group>
        </div>

        <div class="col-md-6">
          <b-form-group
            id="input-group-passportExpiryDate"
            :label="`Expiry date (optional)`"
            label-for="input-passportExpiryDate"
          >
            <b-form-input
              v-model="model.applicant.passportExpiryDate"
              :id="`input-passportExpiryDate`"
              :type="`date`"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <hr />
      <div class="my-3">
        <div class="row">
          <div class="col-6">
            <h3 v-if="getBooking && false" id="calculatedPrice">
              Total: &euro;{{ getBooking.totalAmount | round }}
            </h3>
          </div>
          <div class="col text-right">
            <b-button
              v-if="getBooking.step > getBooking.firstStep"
              type="button"
              variant="default"
              @click="back()"
              >Back</b-button
            >
            <b-button type="submit" variant="primary">Next</b-button>
          </div>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import "../../filters";

export default {
  name: "BookingApplicantAddress",
  data() {
    return {
      model: null,
    };
  },
  components: {},
  computed: {
    ...mapGetters(["getBooking", "getSettings", "getGenderOptions"]),
    countries: function() {
      let vm = this;
      return vm.getSettings ? vm.getSettings.countries : [];
    },
    passportLabel: function() {
      let vm = this;
      return vm.model.euApplicant ? "Passport / ID" : "Passport";
    },
  },
  methods: {
    ...mapActions(["saveBooking", "moveBookingBack", "moveBookingNext"]),
    save() {
      this.next();
    },
    back() {
      // go back
      //const thisStep = this.model.step ? this.model.step : 1;
      // if (thisStep > this.model.firstStep) this.model.step = thisStep - 1;
      this.saveBooking(this.model);
      this.moveBookingBack();
      return false;
    },
    next() {
      // go to next
      //const thisStep = this.model.step ? this.model.step : 1;
      // if (thisStep < this.model.lastStep) this.model.step = thisStep + 1;
      this.saveBooking(this.model);
      this.moveBookingNext();
      return false;
    },
  },
  created() {
    let vm = this;
    if (vm.getBooking) {
      vm.model = JSON.parse(JSON.stringify(vm.getBooking));
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
